module.exports = __webpack_public_path__ + "media/red-winged-blackbird-1.9952adc0.mp3";